/**
 * Session cart guard
 * - Logout: clear cart + advisor context before navigating
 * - Guest page load: if Advisor ID remains in cart or localStorage, wipe cart
 * - Login page load: wipe cart only if Advisor ID is not this customer's advisor_tm/vk
 */
(function () {
  var RELOAD_FLAG = 'vwSessionCartGuardCleared';
  var ADVISOR_LS_KEYS = [
    'Advisor ID',
    'Advisor Name',
    'Advisor Profile Picture',
    'Referral ID',
    'Referral Name',
    'Advisor Storepoint ID'
  ];

  function getSession() {
    return (window.theme && window.theme.customerSession) || {};
  }

  function normalizeAdvisorId(id) {
    if (id == null || id === '') return '';
    return String(id).trim().replace(/^id_/i, '');
  }

  function isBlankAdvisorId(id) {
    var n = normalizeAdvisorId(id);
    return !n || n === '-' || n === 'null' || n === 'undefined';
  }

  function cartRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function clearAdvisorLocalStorage() {
    ADVISOR_LS_KEYS.forEach(function (key) {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        /* ignore */
      }
    });
  }

  function localStorageHasAdvisor() {
    try {
      return !isBlankAdvisorId(localStorage.getItem('Advisor ID'));
    } catch (e) {
      return false;
    }
  }

  function fetchCart() {
    return fetch(cartRoot() + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      return res.json();
    });
  }

  function clearCartLines() {
    return fetch(cartRoot() + 'cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }).then(function (res) {
      return res.json();
    });
  }

  function clearAdvisorAttributes() {
    var empty = {
      'Advisor ID': '',
      'Advisor Name': '',
      'Advisor Profile Picture': '',
      'Previous Demo Experience?': '',
      'Would you like to select a preferred advisor?': ''
    };

    if (typeof CartJS !== 'undefined' && typeof CartJS.setAttributes === 'function') {
      return Promise.resolve(CartJS.setAttributes(empty));
    }

    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ attributes: empty })
    }).then(function (res) {
      return res.json();
    });
  }

  function wipePurchaseContext() {
    clearAdvisorLocalStorage();
    return clearCartLines()
      .catch(function () {
        /* still try attributes */
      })
      .then(function () {
        return clearAdvisorAttributes();
      })
      .catch(function () {
        /* ignore attribute clear failures */
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('advisor:cleared'));
        if (typeof clearAdvisorData === 'function') {
          try {
            clearAdvisorData();
          } catch (e) {
            /* ignore */
          }
        }
      });
  }

  function belongsToCustomer(advisorId, session) {
    var active = normalizeAdvisorId(advisorId);
    if (!active) return true;
    var tm = normalizeAdvisorId(session.advisorTm);
    var vk = normalizeAdvisorId(session.advisorVk);
    return (tm && active === tm) || (vk && active === vk);
  }

  function shouldWipe(cart, session) {
    var cartAdvisorId = cart && cart.attributes ? cart.attributes['Advisor ID'] : '';
    var hasCartAdvisor = !isBlankAdvisorId(cartAdvisorId);
    var hasLsAdvisor = localStorageHasAdvisor();

    if (!session.loggedIn) {
      return hasCartAdvisor || hasLsAdvisor;
    }

    if (hasCartAdvisor && !belongsToCustomer(cartAdvisorId, session)) {
      return true;
    }

    if (hasLsAdvisor) {
      try {
        var lsId = localStorage.getItem('Advisor ID');
        if (!belongsToCustomer(lsId, session)) {
          return true;
        }
      } catch (e) {
        /* ignore */
      }
    }

    return false;
  }

  function bindLogoutClear() {
    document.addEventListener('click', function (event) {
      var link = event.target && event.target.closest
        ? event.target.closest('a[href*="/account/logout"]')
        : null;
      if (!link) return;

      event.preventDefault();
      event.stopPropagation();

      var href = link.href;
      wipePurchaseContext().finally(function () {
        window.location.href = href;
      });
    }, true);
  }

  function runPageLoadGuard() {
    if (sessionStorage.getItem(RELOAD_FLAG) === '1') {
      sessionStorage.removeItem(RELOAD_FLAG);
      return Promise.resolve({ wiped: false });
    }

    var session = getSession();

    return fetchCart()
      .then(function (cart) {
        if (!shouldWipe(cart, session)) {
          return { wiped: false };
        }
        return wipePurchaseContext().then(function () {
          sessionStorage.setItem(RELOAD_FLAG, '1');
          window.location.reload();
          return { wiped: true };
        });
      })
      .catch(function (err) {
        console.warn('session-cart-guard: cart check failed', err);
        return { wiped: false };
      });
  }

  bindLogoutClear();

  function finishGuard(result) {
    if (typeof window.__sessionCartGuardResolve === 'function') {
      window.__sessionCartGuardResolve(result || { wiped: false });
    }
  }

  function start() {
    runPageLoadGuard()
      .then(finishGuard)
      .catch(function () {
        finishGuard({ wiped: false });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
